/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useMemo, useEffect, useState } from "react";

import { useNavigate } from 'react-router-dom';
import Input from '@mui/material/Input';


// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";


// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Link from '@mui/material/Link';
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";

// Material Dashboard 2 PRO React examples
import DataTableHeadCell from "./DataTableHeadCell";
import DataTableBodyCell from "./DataTableBodyCell";
import { styled } from "@mui/system";
function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  table,
  pagination,
  isSorted,
  noEndBorder,
  responseResultCount,
  paginationSize,
  paginationLink,
  pageSelected
}) {
  const navigate   = useNavigate();
  const StyledMDInput = styled(MDInput)(({ theme }) => ({
    "& input[type='number']::-webkit-inner-spin-button, & input[type='number']::-webkit-outer-spin-button": {
      WebkitAppearance: "auto",
      display: "block",
      opacity: 1, 
      color: "red", 
    },
    "& input[type='number']": {
      MozAppearance: "textfield", 
    },
  }));

  const defaultValue = paginationSize ?? entriesPerPage.defaultValue;


  const entries = entriesPerPage.entries
    ? entriesPerPage.entries.map((el) => el.toString())
    : ["5", "10", "15", "20", "25"];
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    //pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // Search input value state
  const [search, setSearch] = useState(globalFilter);
  const [paginationIndex, setPaginationIndex] = useState(pageSelected);

  /* Custom Code */
  const pagesCount  = Math.ceil( responseResultCount / paginationSize );
  const pageOptions = [];

  for (let i = 0; i < pagesCount; i++) {
    pageOptions.push(i);
  }
  /* Custom Code */

  // Set the default value for the entries per page when component mounts
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

  // Set the entries per page value based on the select value
  const setEntriesPerPage = (value) => setPageSize(value);

  // Render the paginations
  const renderPagination = pageOptions.map((option, index) => (
    <Link key={"key-"+index} onClick={() =>{ navigate( paginationLink+(option + 1) ); }}>
      <MDPagination
        item
        key={option}
        onClick={() => gotoPage(Number(option))}
        active={(pageSelected - 1) === option}
      >
        {option + 1}
      </MDPagination>
    </Link>
  )
);

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) => {
    value > pageOptions.length || value <= 0 ? navigate( paginationLink+1) : navigate( paginationLink+(value));
  }

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) => {

    let currentValue = Number(value.value);

    if(currentValue <= 0 || currentValue > pageOptions.length)
    currentValue = 1;

    setPaginationIndex(currentValue);
    navigate( paginationLink+(currentValue));

  }


  // Search input state handle
  const onSearchChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 100);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };


  // Setting the entries starting point
  let entriesStart = 1;

  if(pageSelected > 1)
  entriesStart = (pageSelected - 1) * paginationSize;
  

  // Setting the entries ending point
  let entriesEnd;

  if(pageSelected == 1 && responseResultCount > paginationSize)
  entriesEnd = paginationSize;
  else if(responseResultCount > (pageSelected * paginationSize))
  entriesEnd = pageSelected * paginationSize;
  else 
  entriesEnd = responseResultCount;




  const scrollFn=()=>{
    
    let isMouseDown = false;
let startX;
let startY;
let scrollLeft;
let scrollTop;

const scrollable = document.getElementById('scrollable');

scrollable.addEventListener('mousedown', (e) => {

  isMouseDown = true;
  startX = e.pageX - scrollable.offsetLeft;
  startY = e.pageY - scrollable.offsetTop;
  scrollLeft = scrollable.scrollLeft;
  scrollTop = scrollable.scrollTop;
});

scrollable.addEventListener('mouseleave', () => {
  isMouseDown = false;
  scrollable.style.cursor = "default";
});

scrollable.addEventListener('mouseup', () => {
  isMouseDown = false;
  scrollable.style.cursor = "default";
});

scrollable.addEventListener('mousemove', (e) => {

  if (!isMouseDown) return;
  e.preventDefault();
  const x = e.pageX - scrollable.offsetLeft;
  const y = e.pageY - scrollable.offsetTop;
  const walkX = (x - startX) * 3;
  const walkY = (y - startY) * 3;

  var hasHorizontalScrollbar = scrollable.scrollWidth > scrollable.clientWidth;
  var hasVerticalScrollbar = scrollable.scrollHeight > scrollable.clientHeight;
  if(hasHorizontalScrollbar || hasVerticalScrollbar)
  {
   
    scrollable.style.cursor = "move";
  }

  scrollable.scrollLeft = scrollLeft - walkX;
  scrollable.scrollTop = scrollTop - walkY;
});

  }



  useEffect(() => {
   scrollFn();

  }, []);



  return (
    <TableContainer sx={{ boxShadow: "none" }} className="scrollable" id="scrollable">
      <Table {...getTableProps()} className="scrollableContent" id="scrollableContent">
        <MDBox component="thead">
          {headerGroups.map((headerGroup, key) => (
            <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, idx) => (
                <DataTableHeadCell
                  key={idx}
                  {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
                  width={column.width ? column.width : "auto"}
                  align={column.align ? column.align : "left"}
                  sorted={setSortedValue(column)}
                >
                  {column.render("Header")}
                </DataTableHeadCell>
              ))}
            </TableRow>
          ))}
        </MDBox>
        <TableBody {...getTableBodyProps()}>
          {page.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow key={key} {...row.getRowProps()}>
                {row.cells.map((cell, idx) => (
                  <DataTableBodyCell
                    key={idx}
                    noBorder={noEndBorder && rows.length - 1 === key}
                    align={cell.column.align ? cell.column.align : "left"}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </DataTableBodyCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {rows.length === 0 ?    
        <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="center"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
        >
              <MDBox mb={{ xs: 3, sm: 0 }}>
                <MDTypography variant="button" color="secondary" fontWeight="regular">
                  No records found
                </MDTypography>
              </MDBox>
        </MDBox>
      : <></>} 

      {rows.length > 0 ?
        <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
        >
          {showTotalEntries && (
            <MDBox mb={{ xs: 3, sm: 0 }}>
              <MDTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {responseResultCount} entries 
              </MDTypography>
            </MDBox>
          )}
          {pageOptions.length > 1 && (
            <MDPagination
              variant={pagination.variant ? pagination.variant : "gradient"}
              color={pagination.color ? pagination.color : "info"}
            >
              {canPreviousPage && (
                <MDPagination item onClick={() => previousPage()}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                </MDPagination>
              )}
              {renderPagination.length > 5 ? (
                <MDBox width="5rem" mx={1}>
                 <StyledMDInput
                    inputProps={{ type: "number", min: 1, max: renderPagination.length }}
                    value={pageSelected}
                    onChange={(handleInputPagination, handleInputPaginationValue)}
                  />                
                </MDBox>
              ) : (
                renderPagination
              )}
              {canNextPage && (
                <MDPagination item onClick={() => nextPage()}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                </MDPagination>
              )}
            </MDPagination>
          )}
        </MDBox>
      : <></>}

    </TableContainer>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
};

export default DataTable;
